import { useRouter } from 'next/router'

import { ROUTE } from '@/const'
import { isDenebEnabled } from '@/const/flags'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { WithProxyStoreProps } from './type'

export const withProxyStore = (PageComponent: WithProxyStoreProps) => {
  return function ProxyStoreGuard(props: any) {
    const router = useRouter()
    const { storeCode } = useProxyStore()

    if (!isDenebEnabled) {
      return <PageComponent {...props} />
    }

    if (!storeCode) {
      router.push(ROUTE.selectStore)
      return null
    }

    return <PageComponent {...props} />
  }
}
